import React, { useState, useEffect } from 'react';
import { Col, Form, FormGroup, Modal, ModalBody } from 'reactstrap';
import GoogleLogin from 'react-google-login';

const AddContactModal = ({
  openModal = false,
  onClosed,
}) => {
  const [modal, setModal] = useState(openModal);
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    if (accessToken) {
      toggleModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  useEffect(() => {
    setModal(openModal);
  }, [openModal]);

  const toggleModal = () => setModal(!modal);

  const onModalClosed = () => {
    setModal(false);
    onClosed(accessToken);
  }

  const googleSuccessCallback = (response) => {
    setAccessToken(response.accessToken);
  }

  const googleErrorCallback = (error) => {
    console.log('error : ', error);
  }

  return (
    <Modal isOpen={modal} toggle={toggleModal} size="md" onClosed={onModalClosed}>
      <ModalBody>
        <div className="account-setup-modal">
          <Form className="form-container">
            <div className="form-header mt-md-3 mt-0">
              <h2>ADD CONTACTS</h2>
              <span>MYRA stores these contacts so you can send invitations to your friends.
              To remove them,<br /> visit your <a href="#/">Privacy Settings</a></span>
            </div>
            <FormGroup row>
              <Col sm={12}>
                <GoogleLogin
                  clientId="112440873231-88k0dvt0i2ka3r7fo1k0gn3ru1vu7r1c.apps.googleusercontent.com"
                  render={renderProps => (
                    <button type="button" className="custom-btn-primary" onClick={renderProps.onClick}>
                      GOOGLE (e.g. Gmail)
                    </button>
                  )}
                  responseType="id_token"
                  offline={false}
                  scope="https://www.google.com/m8/feeds"
                  onSuccess={googleSuccessCallback}
                  onFailure={googleErrorCallback}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={12}>
                <button type="button" className="custom-btn-primary" disabled={true}>
                  MICROSOFT (e.g. Outlook)
                </button>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={12}>
                <button type="button" className="custom-btn-primary" disabled={true}>
                  APPLE (e.g. iCloud)
                </button>
              </Col>
            </FormGroup>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  )
};

export default AddContactModal;
